import MarkDown from '@efdigital/ll-addon-content/components/mark-down';
import { Heading } from '@efdigital/ll-addon-ui';
import { Await } from '@warp-drive/ember';

import contentUrl from './coaching-handbook.md?url';

function fetchMarkdown(): Promise<string> {
  return fetch(contentUrl).then((response) => response.text());
}

<template>
  <div class="container py-3">
    <Await @promise={{(fetchMarkdown)}}>
      <:success as |markdown|>
        <Heading
          @size="lg"
          @text="Coaching handbook"
          @secondary="Learn about engagements, session credits, and chemistry calls."
        />
        <MarkDown @markdown={{markdown}} />
      </:success>
    </Await>
  </div>
</template>
